import React, { Component } from 'react';
import { apiPut, apiPost, apiGet, apiDelete } from '../../Api';

export default class RarityDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageFile: null,

            rarity: null
        };
    }


    componentDidUpdate = async (prevProps, prevState) => {
        console.log("update");
        if (this.props.rarityId !== prevProps.rarityId || this.props.creatingNewRarity !== prevProps.creatingNewRarity) {
            this.getRarity();

        }
    }


    getRarity = async () => {
        if (this.props.rarityId != null) {
            if (this.props.rarityId === "") {
                // this.setState({ rarity: null });
                this.setState({
                    rarity: {
                        name: "",
                        shortName: "",
                        flavourText: "",
                        rank: 0,
                        minAffixCount: 0,
                        maxAffixCount: 0,
                        minRollPercentage: 0,
                        maxRollPercentage: 1,
                        possibleStatIds: [],
                        salvageCatalystItemId: "",
                        craftingCoreItemId: "",
                    },
                    imageFile: null,
                    imagePreviewUrl: "",
                });
            }
            else {
                const response = await apiGet("/rarity/" + this.props.rarityId);
                if (response.ok) {
                    const curr = await response.json();
                    this.setState({ rarity: curr });
                    if (curr.imageId) {
                        this.fetchImage();
                    }
                }
            }
        }
        else {
            this.setState({ rarity: null });
        }
    }









    handleInputChange = (event) => {
        const name = event.target.name;
        let value = event.target.value;
        if (event.target.type === "checkbox") {
            value = event.target.checked;
        } else if (event.target.type === "number") {
            const integerFields = new Set([
                "rank",
                "maxStatCount",
                "minAffixCount",
                "maxAffixCount",
            ]);
            const parsed = integerFields.has(name)
                ? Number.parseInt(event.target.value, 10)
                : Number.parseFloat(event.target.value);
            value = Number.isFinite(parsed) ? parsed : 0;
        }
        else {
            value = event.target.value;
        }
        const rarity = { ...this.state.rarity, [name]: value };
        this.setState({ rarity });
    };

    addAnotherStat = (event) => {
        let statId = event.target.value;
        if (!statId || statId === "default") {
            return;
        }
        let stat = this.props.stats.find(x => x.id === statId);
        if (!stat) {
            return;
        }
        // let se = { statId: stat.id, valueFrom: 0, valueTo: 0 };
        let stats;
        if (event.target.name === "possibleStatIds") {
            stats = this.state.rarity.possibleStatIds;
        }
        if (stats == null) {
            stats = [];
        }

        if (stats.includes(stat.id)) {
            return;
        }

        this.setState({
            rarity: {
                ...this.state.rarity,
                [event.target.name]: [...stats, stat.id],
            },
        });
    }

    removeStat = (event) => {
        let rarity = this.state.rarity;
        rarity.possibleStatIds = rarity.possibleStatIds.filter(x => x !== event.target.name);
        this.setState({ rarity });
    }

    render() {
        const { onUpdate, onDelete, onCreate, creatingNewRarity, onCancelCreate, stats, items = [] } = this.props;
        const { rarity } = this.state;

        if (!rarity || rarity == null) return <div>Select a rarity to see details</div>;

        return (
            <div className='admin_details'>
                <label>Name:
                    <input type="text" name="name" value={rarity.name} onChange={this.handleInputChange} />
                </label>

                <label>colorHex:
                    <input type="text" name="colorHex" value={rarity.colorHex} onChange={this.handleInputChange} />
                    <div style={{ width: '100px', height: '10px', backgroundColor: rarity.colorHex }}></div>
                </label>

                <label>DropChance:
                    <input type="number" step="0.01" name="dropChance" value={rarity.dropChance} onChange={this.handleInputChange} />

                </label>

                <label>Rarity Rank:
                    <input type="number" min="0" step="1" name="rank" value={rarity.rank ?? 0} onChange={this.handleInputChange} />
                </label>
                <label>Minimum Affix Count:
                    <input type="number" min="0" step="1" name="minAffixCount" value={rarity.minAffixCount ?? 0} onChange={this.handleInputChange} />
                </label>
                <label>Maximum Affix Count:
                    <input type="number" min="0" step="1" name="maxAffixCount" value={rarity.maxAffixCount ?? 0} onChange={this.handleInputChange} />
                </label>
                <label>Minimum Roll Percentage:
                    <input type="number" min="0" max="1" step="0.01" name="minRollPercentage" value={rarity.minRollPercentage ?? 0} onChange={this.handleInputChange} />
                </label>
                <label>Maximum Roll Percentage:
                    <input type="number" min="0" max="1" step="0.01" name="maxRollPercentage" value={rarity.maxRollPercentage ?? 1} onChange={this.handleInputChange} />
                </label>

                <label>MaxStatCount:
                    <input type="number" name="maxStatCount" value={rarity.maxStatCount} onChange={this.handleInputChange} />
                </label>
                <label>MaxPercentageOfValueOfStats:
                    <input type="number" step="0.01" min="0" max="1" name="maxPercentageOfValueOfStats" value={rarity.maxPercentageOfValueOfStats} onChange={this.handleInputChange} />
                </label>

                <label>Salvage Catalyst Item:
                    <select
                        name="salvageCatalystItemId"
                        value={rarity.salvageCatalystItemId ?? ""}
                        onChange={this.handleInputChange}
                    >
                        <option value="">No catalyst</option>
                        {rarity.salvageCatalystItemId
                            && !items.some(item => item.id === rarity.salvageCatalystItemId)
                            ? (
                                <option value={rarity.salvageCatalystItemId}>
                                    Missing item ({rarity.salvageCatalystItemId})
                                </option>
                            )
                            : null}
                        {items.map(item => (
                            <option key={item.id} value={item.id}>
                                {item.name || item.id}
                            </option>
                        ))}
                    </select>
                </label>

                <label>Additional Crafting Core Item:
                    <select
                        name="craftingCoreItemId"
                        value={rarity.craftingCoreItemId ?? ""}
                        onChange={this.handleInputChange}
                    >
                        <option value="">No additional core</option>
                        {rarity.craftingCoreItemId
                            && !items.some(item => item.id === rarity.craftingCoreItemId)
                            ? (
                                <option value={rarity.craftingCoreItemId}>
                                    Missing item ({rarity.craftingCoreItemId})
                                </option>
                            )
                            : null}
                        {items.map(item => (
                            <option key={item.id} value={item.id}>
                                {item.name || item.id}
                            </option>
                        ))}
                    </select>
                </label>



                <div className='section2'>
                    <h3>Possible Stats:</h3>
                    {stats.map((obj, index) => {
                        // const foundStat = item.stats?.statEntries.find(x => x.name === obj.name);
                        const foundStats = rarity.possibleStatIds?.filter(x => x === obj.id);
                        return foundStats?.map((foundStat) => {
                            return (
                                <label>{obj.name}:
                                    <div className='statEntryDefinitionValue'><button name={obj.id} onClick={this.removeStat}>delete</button></div>

                                </label>);
                        });
                    })}



                    <div><label>Add another stat/proc:</label>
                        <select
                            name="possibleStatIds"
                            value={0}
                            onChange={this.addAnotherStat}
                        >
                            <option key={-1} value="default">Add Stat</option>
                            {stats.map((obj, index) =>
                                <option key={index} value={obj.id}>{obj.name}</option>
                            )}

                        </select>
                    </div>
                </div>


                {creatingNewRarity ?
                    <div>
                        {/* Form to create a new rarity, similar to the update form... */}
                        <button onClick={() => onCreate(rarity)}>Create</button>
                        <button onClick={() => onCancelCreate()}>Cancel</button>
                    </div>
                    :
                    <div>
                        <button onClick={() => onUpdate(rarity)}>Update</button>
                        <button onClick={() => onDelete(rarity)}>Delete</button>
                    </div>
                }


            </div>
        );


    }

}
